<style lang="stylus">
.idverify {
  padding: 24px !important;
}

.step-1-verification-header {
  font-size: 24px;
  font-weight: 600;
  margin: 0px 0 32px;
  text-align: center;
}

.step-1-card-header {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  background-color: #F1F1F1;
  padding: 15px 24px;
}

.step-1-card-content {
  border: 1px solid #F1F1F1;
  min-height: 125px;
  padding: 24px 24px 24px 24px;
  font-weight: 400;
  font-size: 16px;
  color: #747474;
}

.step-1-card-2-content {
  padding: 12px 24px 12px 24px;
}

.step-1-take-photo-bg {
  background-color: #F1F1F1;
}

.take-photo-white-bg {
  margin: 86px 0 80px 0;
  background-color: white;
}

.take-your-photo {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  padding: 34px;
}

.take-photo-steps {
  font-weight: 600;
  font-size: 18px;
  padding-bottom: 16px;
}

.step-1-question-header {
  color: #747474;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.step-1-question-content {
  color: #747474;
  font-size: 16px;
  margin-right: 48px;
  font-weight: 400;
}

.image-display-face-bg {
  margin-top: 24px;
  height: 254.25px;
  width: 400px;
  background-color: #D0D0D0;
  display: inline-block;
  text-align: center;
  text-align: -webkit-center;
}

.image-capture-component {
  height: 254.25px;
  width: 452px;
  display: inline-block;
  margin: 24px;
  margin-bottom: 0;
}

.grey-bg-take-photo {
  height: 351px;
}

.video-icon {
  width: 185px;
  height: 48px !important;
  border-radius: 25px !important;
  color: white !important;
}

.camera-icon {
  height: 48px !important;
  border-radius: 25px !important;
  color: white !important;
}

.take-photo-content {
  margin-right: 30px;
}

.successful-photo-text {
  font-size: 16px;
}

.take-photo-of-id {
  display: inline-block;
  font-size: 16px;
  color: #747474;
  font-weight: 400;
  width: 92px;
}

.take-photo-questions {
  color: #2A2A2A;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  padding: 32px 0 0 0;
}

.yellowCircle-take-photo {
  font-size: 24px;
  color: rgb(51, 49, 48);
  background-color: #ffc527;
  border: 2px solid #ffc527;
  border-radius: 50%;
  padding: 6px 7.63px 6px 13.63px;
  margin-right: 10px;
  font-weight: bold;
}

.begin-button {
  border-radius: 25px !important;
  border: 2px solid #FFC627 !important;
  font-sizee: 18px;
  font-weight: 600;
  padding: 12px 36px 12px 32px;
  background: white;
}

.lets-begin-button:hover {
  cursor: pointer;
}

.lets-begin-button {
  text-align: center;
  position: absolute;
  left: 45%;
  margin: -13px;
}

.border-seperator {
  padding-bottom: 36px;
  border-bottom: 1px solid #F1F1F1;
}

@media (max-width: 1024px) {
  .lets-begin-button {
    left: 39%;
  }
}

@media (max-width: 1200px) {
  .step-1-take-photo-bg {
    background-color: white;
  }

  .take-photo-white-bg {
    margin: 86px 0 0px 0;
  }

  .step-1-question-content {
    margin-right: 48px;
  }
}

@media (min-width: 600px) and (max-width: 1024px) {
  .plus-icon {
    padding: 10px 0;
  }

  .lets-begin-button {
    left: 41%;
  }

  .grey-bg-take-photo {
    margin-bottom: 32px;
  }
}

@media (max-width: 768px) {
  .idverify::after {
    content: '';
    display: block;
    position: relative;
    top: 25px;
    border-bottom: 1px solid #d0d0d0;
  }
}

@media (max-width: 600px) {
  .step-1-verification-header {
    font-size: 18px;
    margin-bottom: 24px;
  }

  .step-1-card-header {
    padding: 12px 24px;
    width: 100%;
  }

  .step-1-card-content {
    padding: 27px 24px;
    height: auto;
    width: 100%;
  }

  .plus-icon {
    padding: 10px 0;
  }

  .take-your-photo {
    font-size: 24px;
    padding: 32px 0;
  }

  .grey-bg-take-photo {
    height: 465px;
    width: 100%;
  }

  .image-display-face-bg {
    height: 371px;
    width: 80%;
    margin: 23px 34px 0 33px;
    text-align: center;
    text-align: -webkit-center;
  }

  .image-capture-component {
    height: 371px;
    width: 80%;
    margin: 23px 34px 0 33px;
  }

  .take-photo-steps, .generic-left-margin, .success-photo-list {
    font-size: 16px;
  }

  .retake-photo-step {
    font-size: 16px;
  }

  .step-1-question-content {
    margin: 0 0 32px 0;
  }

  .step-1-take-photo-bg {
    background-color: white;
  }

  .take-photo-questions {
    text-align: left;
  }

  .take-photo-white-bg {
    margin: 0px;
  }

  .camera-icon {
    color: white !important;
  }

  .lets-begin-button {
    left: 33%;
  }
}

@media (max-width: 375px) {
  .lets-begin-button {
    left: 30%;
  }
}

@media (max-width: 320px) {
  .lets-begin-button {
    left: 27%;
  }
}

.v-btn.valid-id-button {
  background-color: #fec627 !important;
  color: black !important;
}

.v-btn.invalid-id-button {
  background-color: #d7d7d7 !important;
  color: #666666 !important;
}
</style>
<template>
  <div v-if="display">
    <v-container class="idverify">
      <v-row id="step-header" align-center justify="center" wrap no-gutters>
        <v-col cols="8" sm="8" md="8" v-if="step < 4">
          <id-verify-step-component :step="step" />
        </v-col>
      </v-row>
      <v-divider v-if="step === 1" />
      <v-divider v-if="step !== 1" class="d-flex d-sm-none" style="margin-bottom: 0" />
      <v-row align-center justify="center" wrap v-if="step == 1" style="margin-bottom: 4rem">
        <v-col cols="12" sm="11" md="10" xl="12">
          <div class="step-1-verification-header">What you need for verification</div>
          <v-row wrap justify="center">
            <v-col cols="12" sm="5" md="4" xl="2">
              <div class="step-1-card-header">
                <v-icon color="#2A2A2A" size="26px" style="padding-right: 8px; vertical-align: sub">mdi-webcam</v-icon
                >Webcam
              </div>
              <div class="step-1-card-content">
                You will be prompted to take a webcam photo of yourself as well as an acceptable form of photo ID.
              </div>
            </v-col>
            <v-col cols="12" sm="1" md="1" xl="2" style="text-align: center">
              <v-icon class="plus-icon" style="padding-top: 15px" color="#E8E8E8">mdi-plus</v-icon>
            </v-col>
            <v-col cols="12" sm="5" md="4" xl="2">
              <div class="step-1-card-header">
                <v-icon color="#2A2A2A" light size="20px" style="padding-right: 8px"
                  >mdi-card-account-details-outline</v-icon
                >Photo identification
              </div>
              <div class="step-1-card-content step-1-card-2-content">
                Acceptable forms of photo IDs include a driver’s license, passport, national ID card, state or province
                ID card, or an official student ID card.
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="lets-begin-button" @click="scrollto()" v-if="step == 1">
      <span class="begin-button" @click="asuoDataLayerClick('idVerifiyStep1', '0')" color="white">
        Let's begin
        <v-icon size="18px" style="padding-left: 6px" color="black">mdi-chevron-down</v-icon>
      </span>
    </div>
    <!-- STEP 1 -->
    <v-row class="step-1-take-photo-bg" align-center justify="center" row wrap v-if="step == 1">
      <v-container style="padding: 24px">
        <v-col cols="12" md="12">
          <div class="take-photo-white-bg">
            <v-container class="container">
              <v-row column>
                <v-col cols="12" sm="12" md="12">
                  <div class="take-your-photo" id="takePhoto">
                    <span class="yellowCircle-take-photo">1&nbsp;</span>Take your photo
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-row wrap justify-space-around>
                    <v-col cols="12" sm="12" md="12" lg="5" style="text-align: -webkit-center">
                      <image-capture-component @clickedImage="clickedImage" @retakeImage="retakeImage" :step="1" />
                    </v-col>
                    <v-col lg="1" />
                    <v-col cols="10" sm="12" md="12" lg="6">
                      <div style="line-height: 22px" class="take-photo-steps">
                        First, click the “use my camera” button, to allow this page to use your webcam.
                      </div>
                      <div class="take-photo-steps">
                        To take a photo of yourself, click the camera button (
                        <v-icon color="black" size="20px">mdi-camera</v-icon>&nbsp;).
                      </div>
                      <div style="font-weight: 400; margin-bottom: 32px" class="retake-photo-step">
                        To retake your photo, click the camera button (
                        <v-icon color="black" size="20px">mdi-camera</v-icon>&nbsp;) again.
                      </div>
                      <div class="take-photo-steps successful-photo-text">For a successful photo, make sure that:</div>
                      <div
                        style="margin-bottom: 12px; font-size: 16px; padding-left: 13px; font-weight: 400"
                        class="success-photo-list"
                      >
                        <div
                          style="
                            background-color: black;
                            width: 8px;
                            height: 8px;
                            border-radius: 5px;
                            display: inline-block;
                            margin-right: 12px;
                          "
                        />
                        Your face is well-lit.
                      </div>
                      <div
                        class="success-photo-list"
                        style="margin-bottom: 32px; font-size: 16px; padding-left: 13px; font-weight: 400"
                      >
                        <div
                          style="
                            background-color: black;
                            width: 8px;
                            height: 8px;
                            border-radius: 5px;
                            display: inline-block;
                            margin-right: 12px;
                          "
                        />
                        Your entire face fits inside the frame.
                      </div>
                      <div style="margin-bottom: 36px; font-size: 16px; font-weight: 400" class="generic-left-margin">
                        When you’re satisfied with your photo, click “Next.”
                      </div>
                      <div class="nextButton generic-left-margin" style="display: flex; align-items: center">
                        <v-btn
                          @click="
                            asuoDataLayerClick('idVerifiyStep1', '4', {});
                            step = 2;
                          "
                          :ripple="false"
                          variant="flat"
                          style="margin-left: 0"
                          :class="!!faceImage ? 'invalid-button' : ''"
                          :disabled="faceImage"
                        >
                          <span style="padding-left: 17px">Next</span>
                          <v-icon left style="margin: 0 10px">mdi-arrow-right</v-icon>
                        </v-btn>
                        <span class="take-photo-of-id">Take a photo of your ID</span>
                      </div>
                    </v-col>
                    <v-col lg="1" />
                  </v-row>
                  <v-divider />
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <div class="step-1-question-header">Why does ASU need my photo?</div>
                      <div class="step-1-question-content">
                        To be eligible for academic credit, you must verify your identification so we know who you are.
                        This lets us ensure the academic credit you earn appears on your official ASU transcript.
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <div class="step-1-question-header">What does ASU do with this photo?</div>
                      <div class="step-1-question-content">
                        We use the highest levels of security available to encrypt your photo and send it to our
                        authorization service for review. Your photo and information are not saved or visible anywhere
                        on ASU after the verification process is complete.
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="6"
                      class="take-photo-questions d-flex d-sm-none"
                      style="flex-wrap: nowrap"
                    >
                      <div>
                        <span style="font-weight: 600">Questions?</span>&nbsp;Please&nbsp;
                        <span
                          style="color: #8c1d40; text-decoration: underline"
                          @click="asuoDataLayerClick('idVerifiyStep1', '5', {})"
                          v-on:click="gotoFAQ()"
                          >read our FAQ</span
                        >
                        &nbsp;to view common questions.
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-container>
    </v-row>

    <!-- STEP 2 -->
    <id-verify-photo-id @goToStep="goToStep($event)" v-if="step == 2" />

    <!-- STEP 3 -->
    <image-display-component @goToStep="goToStep($event)" v-if="step == 3" />
    <div class="take-photo-questions d-none d-sm-flex justify-center" style="margin-bottom: 28px" v-if="step < 4">
      <span style="font-weight: 600">Questions?</span>&nbsp;Please&nbsp;
      <a
        :href="ulcPartnerFlag ? 'https://ulc.asu.edu/about/faq' : 'https://ea.asu.edu/about/faq'"
        style="color: #8c1d40; text-decoration: underline"
        class="mx-1"
        @click="asuoDataLayerClick('idVerifiyStep1', '5', {})"
        >read our FAQ</a
      >
      &nbsp;to view common questions.
    </div>
    <id-verify-thank-you-component v-if="step == 4" />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import { useUiStore } from '@/stores/ui';
import { useViewAsStore } from '@/stores/viewAs';
import { isFeatureEnabled } from '../../feature-flags';

import IdVerifyStepComponent from '../components/IDVerifyStepComponent.vue';
import IdVerifyPhotoId from '../components/IDVerifyPhotoID.vue';
import ImageDisplayComponent from '../components/ImageDisplayComponent.vue';
import IdVerifyThankYouComponent from '../components/IDVerifyThankYouComponent.vue';
import ImageCaptureComponent from '../components/ImageCaptureComponent.vue';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers.js';

export default defineComponent({
  data() {
    return {
      step: 1,
      canvas: {},
      camera: false,
      faceImage: true,
      display: false
    };
  },

  mixins: [Helper, DataLayerMixin, AjaxLoader],

  components: {
    IdVerifyStepComponent,
    IdVerifyPhotoId,
    ImageDisplayComponent,
    IdVerifyThankYouComponent,
    ImageCaptureComponent
  },

  methods: {
    gotoFAQ() {
      window.open(this.ulcPartnerFlag ? 'https://ulc.asu.edu/about/faq' : 'https://ea.asu.edu/about/faq', '_blank');
    },
    retakeImage() {
      this.faceImage = true;
    },
    clickedImage() {
      this.faceImage = false;
    },
    goToStep(event) {
      this.step = event.step;

      this.scrollto();
    },
    scrollto() {
      let pos = document.getElementById('takePhoto') != null ? document.getElementById('takePhoto').offsetTop : 0;

      window.scrollBy(0, pos - 150);
    }
  },

  computed: {
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    }
  },

  async created() {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    if (!authStore.auth) {
      this.$router.push({ name: 'WelcomeDesktop' });
      return;
    }

    // Block the whole flow — an admin must never submit ID docs on another learner's behalf.
    // hasPendingSession covers a refresh/deep-link that lands here before restoration finishes.
    const viewAsStore = useViewAsStore();
    if (viewAsStore.isActive || viewAsStore.hasPendingSession) {
      useUiStore().showWarningNotification(
        'Action unavailable',
        'ID verification cannot be submitted while viewing as another user.'
      );
      this.$router.push({ name: 'dashboard' });
      return;
    }

    if (!Object.keys(userStore.apis.learnerData).length) {
      await this.$conn.initSecureSession().then();
    }

    if (['submitted', 'approved', 'verified'].indexOf(userStore.apis.learnerData._idVerify) >= 0) {
      this.$router.push({ name: 'dashboard' });
      return;
    }

    // ULC-3056: feature-flag swap to Aether-hosted magic-link IDV.
    // When the api-hub kill switch is OFF, the initiate call returns 503 and we fall
    // through to the legacy 4-step capture so the learner is never blocked.
    if (isFeatureEnabled('MAGIC_LINK_IDV')) {
      try {
        const response = await this.$conn.initiateIdVerification({
          learnerId: userStore.apis.learnerData._learnerId,
          source: 'EA'
        });
        if (response?.authorize_url) {
          sessionStorage.setItem('idvState', response.state || '');
          window.location.href = response.authorize_url;
          return;
        }
      } catch (err) {
        console.warn('Magic-link IDV unavailable, falling back to legacy capture:', err);
      }
    }

    this.display = true;
  }
});
</script>
